import { Stack, Box, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function MembersTab({
  loading,
  studentIds,
  studentDetails,
  adultIds,
  adultDetails,

  onAddStudents,
  onRemoveStudent,
  onAddAdults,
  onRemoveAdult,

  addStudentsInput,
  setAddStudentsInput,
  addAdultsInput,
  setAddAdultsInput,

  newStudentsCount,
  setNewStudentsCount,
  onAddNewStudents,

  // ✅ NEW adult creation props
  newAdultsCount,
  setNewAdultsCount,
  onAddNewAdults,
  creatingStudents = false,
  creatingAdults = false,
}) {

  return (
  
    <Stack spacing={3}>
      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={18} /> <span>Loading members…</span>
        </Box>
      ) : (
        <>
          {/* Add Students */}
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Add students by ID (comma/space separated)"
              value={addStudentsInput}
              onChange={(e) => setAddStudentsInput(e.target.value)}
              fullWidth
            />
            <IconButton color="primary" onClick={onAddStudents} title="Add students">
              <AddIcon />
            </IconButton>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Create new students (count)"
              value={newStudentsCount}
              onChange={(e) => setNewStudentsCount(e.target.value)}
              type="number"
              inputProps={{ min: 1, max: 200 }}
              sx={{ maxWidth: 280 }}
              disabled={creatingStudents}
            />
            <IconButton
              color="primary"
              onClick={onAddNewStudents}
              title="Create and add"
              disabled={creatingStudents}
            >
              {creatingStudents ? <CircularProgress size={18} /> : <AddIcon />}
            </IconButton>
            {creatingStudents && (
              <Box sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
                Creating students…
              </Box>
            )}
          </Stack>

          <Table size="small" sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                <TableCell width={80}>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Nationality</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(studentDetails.length ? studentDetails : (studentIds || []).map(id => ({ id }))).map(s => {
                const name = [s.studentName, s.studentSurname, s.name].filter(Boolean).join(" ") || `Student ${s.id}`;
                return (
                  <TableRow key={`s-${s.id}`}>
                    <TableCell>{s.id}</TableCell>
                    <TableCell>{name}</TableCell>
                    <TableCell>{s.studentNationality || <em>—</em>}</TableCell>
                    <TableCell align="right">
                      <IconButton size="small" color="error" onClick={() => onRemoveStudent(s.id)} title="Remove">
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
              {(!studentIds || studentIds.length === 0) && (
                <TableRow>
                  <TableCell colSpan={4}><em>No students</em></TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {/* Add Adults */}
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Add adults by ID (comma/space separated)"
              value={addAdultsInput}
              onChange={(e) => setAddAdultsInput(e.target.value)}
              fullWidth
            />
            <IconButton color="primary" onClick={onAddAdults} title="Add adults">
              <AddIcon />
            </IconButton>
          </Stack>
          {/* ✅ NEW: Create Adults */}
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Create new adults (count)"
              value={newAdultsCount}
              onChange={(e) => setNewAdultsCount(e.target.value)}
              type="number"
              inputProps={{ min: 1, max: 200 }}
              sx={{ maxWidth: 280 }}
              disabled={creatingAdults}
            />
            <IconButton
              color="primary"
              onClick={onAddNewAdults}
              title="Create and add"
              disabled={creatingAdults}
            >
              {creatingAdults ? <CircularProgress size={18} /> : <AddIcon />}
            </IconButton>
            {creatingAdults && (
              <Box sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
                Creating adults…
              </Box>
            )}
          </Stack>

          <Table size="small" sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                <TableCell width={80}>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(adultDetails.length ? adultDetails : (adultIds || []).map(id => ({ id }))).map(a => {
                const name = a.adultName || a.adultSurname || a.name
                  ? [a.adultName, a.adultSurname, a.name].filter(Boolean).join(" ")
                  : `Adult ${a.id}`;
                return (
                  <TableRow key={`a-${a.id}`}>
                    <TableCell>{a.id}</TableCell>
                    <TableCell>{name}</TableCell>
                    <TableCell>{a.notes || <em>—</em>}</TableCell>
                    <TableCell align="right">
                      <IconButton size="small" color="error" onClick={() => onRemoveAdult(a.id)} title="Remove">
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
              {(!adultIds || adultIds.length === 0) && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <em>No adults</em>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </>
      )}
    </Stack>
  );
}
